var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 533.271 512",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.497 298.687H81.837L196.427 0h141.857l194.987 512H375.796l-37.867-103.991H192.88L155.013 512H0l50.807-132.432H172.97zm-79.282-28.447H212.9l52.505-143.583 62.906 172.03h-95.506l-29.523 80.881h154.557l37.873 103.988h96.285L318.683 28.443H215.978zm119.985 0h44.427l-22.223-60.756zm-80.588 137.769h-92.25l-28.983 75.547h93.719z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default ForwardRef;